<template>
    <div class="CaseFileSectionDocuments">
        <Vuetable :fields="DocumentsTableOptions.Fields"
                  :data="Documents"
                  pagination-path=""
                  :api-mode="false"
                  :detail-row-component="CaseFileSectionDocumentsObj"
                  track-by="SectionName"
                  ref="documentstable">


            <template slot="Actions" scope="props">
                <div class="horizontal-icons-padded">
                    <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.PDFFileID, props.rowData.FormLabel, props.rowData.PDFFileName, props.rowData.DocumentID)" class="pointer" /></span>
                    <span v-if="CheckPermission('CaseFile.PerformOperations') && props.rowData.Actions != 'Locked'"><font-awesome-icon :icon="['fas', 'wrench']" v-on:casefileupdated="OnCaseFileUpdated" v-on:click="OpenDocumentMiscOptions(props.rowData.ChartID, props.rowData.DocumentAuthorEmployeeID, props.rowData.DocumentID)" class="pointer" /></span>
                </div>
            </template>
        </Vuetable>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false"/>
        <DocumentMiscOptions ref="document-misc-options-modal-component" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faWrench } from '@fortawesome/free-solid-svg-icons';
    library.add(faWrench);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);

    import DocumentViewer from "./DocumentViewer.vue";
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import DocumentMiscOptions from "./DocumentMiscOptions.vue";
    

    export default {
        props: {
            rowData: {
                type: Object,
                required: true
            },
            rowIndex: {
                type: Number
            },
            options: {
                type: Object,
            }
        },
        data: function () {
            return {
                DocumentsTableOptions: {
                    Fields: [
                        {
                            name: 'FormLabel',
                            title: 'Name',
                            titleClass: 'document-header',
                        },
                        {
                            name: 'EffectiveDate',
                            title: 'Date',
                            titleClass: 'document-header',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'DocumentAuthorName',
                            title: 'Author',
                            titleClass: 'document-header',
                        },
                        {
                            name: '__slot:Actions',
                            title: '',
                            titleClass: 'document-header',
                            dataClass: 'right-aligned',
                        }
                    ]
                }
            }
        },
        methods: {
            ViewDocument(pdfFileID, formLabel, documentName, documentID) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName, documentID);
            },
            OpenDocumentMiscOptions(chartID, authorEmployeeID, documentID) {
                this.$refs['document-misc-options-modal-component'].ShowModal(chartID, authorEmployeeID, documentID, true, true, true);
            },
            OnCaseFileUpdated() {
                this.$emit('casefileupdated');
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            DocumentViewer,
            Vuetable,
            DocumentMiscOptions
        },
        computed: {
            Documents: function () {
                return this.rowData.Documents;
            },
        },
        mounted: function () {
            let vm = this;
            setTimeout(function () {
                vm.$refs.documentstable.setData(vm.Documents);
            }, 150);
        }
    }
</script>

<style scoped>

    table {
        table-layout: fixed;
    }

    /deep/ .right-aligned {
        text-align: right;
    }

    .horizontal-icons-padded span {
        padding-right: 20px;
    }
</style>